import Container from "abusesa-js/Container";

import {schemeCategory10, schemeCategory20} from "d3-scale";

export default class ColorMap {

    constructor(options) {
        this._options = new Container(options || {});
        this._mapped = null;
        this._index = null;
        this._colors = null;
        this.domain();
    }

    clear() {
        this._mapped = {};
        this._index = 0;

        const hardCoded = this._options.get("map", {});
        Object.keys(hardCoded).forEach(function(name) {
            this._mapped[name] = hardCoded[name];
        }, this);
    }

    get(name) {
        const map = this._mapped, colors = this._colors;

        if (!map[name]) {
            map[name] = colors[this._index];
            this._index = (this._index + 1) % colors.length;
        }

        return map[name];
    }

    domain(items) {
        this.clear();
        // https://github.com/d3/d3-scale#category-scales
        if (items === void 0 || items.length <= 10) {
            this._colors = schemeCategory10.slice();
        } else {
            let SHIFT_BY = 5;
            this._colors = [];
            let dark = schemeCategory10.slice();
            let lighter = schemeCategory20.slice().filter((val, i) => i % 2 == 1);
            // the default 20-category color-scheme has
            // every other color as "lighter" version of the
            // previous one... change the order so that
            //highlighted  groups are easier to see
            for (let i = 0; i < dark.length; i++) {
                this._colors.push(dark[i]);
                this._colors.push(lighter[(i + SHIFT_BY) % (lighter.length - 1)]);
            }
        }

        (items || []).forEach(this.get.bind(this));

        return this;
    }
}




// WEBPACK FOOTER //
// ./src/kpi/lib/ColorMap.js